import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignListComponent } from './components/campaign-list/campaign-list.component';
import { CardCampaignComponent } from './components/card-campaign/card-campaign.component';
import { createCustomElement } from '@angular/elements';
import { AllBidsComponent } from './components/all-bids/all-bids.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { CoreModule } from '../core/core.module';
import { AuctionItemModalComponent } from './components/auction-item-modal/auction-item-modal.component';
import { RecommendItemsComponent } from './components/recommend-items/recommend-items.component';
import { BidTypeSwitcherComponent } from './components/bid-type-switcher/bid-type-switcher.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from 'ngx-currency';
import { InputMaskModule } from '@ngneat/input-mask';
import { ToastModule } from '../toast/toast.module';
import { DialogModule } from 'app/dialog/dialog.module';
import { FeaturedItemsComponent } from './components/featured-items/featured-items.component';

@NgModule({
  declarations: [CampaignListComponent, CardCampaignComponent, AllBidsComponent, AuctionItemModalComponent, RecommendItemsComponent, BidTypeSwitcherComponent, FeaturedItemsComponent, RecommendItemsComponent ],
  imports: [
    CommonModule,
    MdbTabsModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true }),
    ToastModule,
    DialogModule,
    NgxCurrencyDirective
  ],
  providers: [provideEnvironmentNgxCurrency({
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 0,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Financial
  })],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DonorPageModule {
  constructor(injector: Injector) {
    const AllBidsElement = createCustomElement(AllBidsComponent, {injector});
    const CardCampaignElement = createCustomElement(CardCampaignComponent, {injector});
    const CampaignListElement = createCustomElement(CampaignListComponent, {injector});

    try {
      customElements.define('paybee-donor-page-all-bids-element', AllBidsElement);
      customElements.define('paybee-donor-page-card-campaign-element', CardCampaignElement);
      customElements.define('paybee-donor-page-campaign-list-element', CampaignListElement);
    } catch(e) {}
  }
}
